export default [
  {
    path: '/ai-usage/keywords',
    name: 'ai-usage-keywords',
    component: () => import('@/views/ai-usage/AiKeywordLogList.vue'),
    meta: {
      resource: 'MailLog',
      action: 'read',
    },
  },
]
